const state = {
  cards: [
    {
      card_type_id: 0,
      card_type_code: "VI",
      card_type_name: "Неизвестная",
      class: "c-unknown"
    },
    {
      card_type_id: 1,
      card_type_code: "VI",
      card_type_name: "Visa",
      class: "c-visa"
    },
    {
      card_type_id: 2,
      card_type_code: "CA",
      card_type_name: "Mastercard",
      class: "c-mastercard"
    },
    {
      card_type_id: 3,
      card_type_code: "AX",
      card_type_name: "American Express",
      class: "c-amex"
    },
    {
      card_type_id: 4,
      card_type_code: "DC",
      card_type_name: "Diners Club",
      class: "c-diners"
    },
    {
      card_type_id: 5,
      card_type_code: "TO",
      card_type_name: "Maestro",
      class: "c-maestro"
    },
    {
      card_type_id: 7,
      card_type_code: "DS",
      card_type_name: "Discover",
      class: "c-discover"
    },
    {
      card_type_id: 8,
      card_type_code: "JC",
      card_type_name: "JCB",
      class: "c-jcb"
    },
    {
      card_type_id: 9,
      card_type_code: "MI",
      card_type_name: "МИР",
      class: "c-mir"
    }
  ],
  paymentType: [
    {
      type: "APPLE PAY",
      img: "https://static-evo.mapcard.pro/static/bo/images/apple_pay.png"
    },
    {
      type: "GOOGLE PAY",
      img: "https://static-evo.mapcard.pro/static/bo/images/google_pay.svg"
    },
    {
      type: "IPS",
      img: "https://static-evo.mapcard.pro/static/bo/images/logo-sbp.svg"
    }
  ]
};

const getters = {
  cardClass: state => id => {
    let item = state.cards.find(el => el.card_type_id == id);
    return item ? item.class : "";
  },
  cardName: state => id => {
    let item = state.cards.find(el => el.card_type_id == id);
    return item ? item.card_type_name : "";
  },
  holderImg: state => name => {
    let item = state.paymentType.find(el => el.type === name);
    return item ? item.img : "";
  }
};

export default {
  state,
  getters
};
